import Modal from "../modal/Modal";
import PositionForm from "../../containers/positions/PositionForm";
import { Button } from "../buttons";

function AddPositionModal({
  openModal,
  setOpenModal,
  positionForm,
  setPositionForm,
  submitHandler,
  errors,
  features,
  children,
  buttonId
}) {
  return (
    <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}>
      <Modal.Header>新しい職位を追加します</Modal.Header>
      <Modal.Body className="overflow-y-auto">
        {children}
        <PositionForm
          positionForm={positionForm}
          setPositionForm={setPositionForm}
          errors={errors}
          features={features}
        />
      </Modal.Body>
      <Modal.Footer className="space-x-[32px]">
        <div className="w-1/2">
          <Button
            color="light"
            className="w-full"
            onClick={() => setOpenModal(false)}
          >
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button
            color="primary"
            className="w-full"
            onClick={submitHandler}
            id={buttonId}
          >
            新規追加
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default AddPositionModal;
